import React from 'react';
import PropTypes from 'prop-types';

import OverrideButton from './override_button';
import { Row, Col } from 'react-bootstrap-5';

function RadioInput({ checked, disabled, id, onChange, name, label }) {
  return (
    <div className="form-check">
      <input
        checked={checked}
        className="form-check-input"
        disabled={disabled}
        id={id}
        name={name}
        type="radio"
        onChange={onChange}
      />
      <label className="form-check-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
}

RadioInput.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default function PageTemplateStyleSelector({ pageTemplateStyleId, pageTemplateStyles, onUpdate, onRemove }) {
  const disabled = !pageTemplateStyleId;
  return (
    <Row className="align-items-center">
      <Col md={6} xs={8}>
        <div className="form-group flex-grow-1 mb-0">
          <Row className="g-0">
            <Col className="p-0" xs={3}>
              <div className="d-flex h-100 align-items-center px-2 py-1 bg-light border border-end-0">
                <span className="form-label mb-0">Page Layout</span>
              </div>
            </Col>
            <Col className={`px-4 py-1 border ${disabled ? 'd-flex align-items-center' : ''}`} xs={9}>
              {disabled && (
                <span className="text-muted">Buildout Default</span>
              )}
              {!disabled && pageTemplateStyles.map(layout => (
                <RadioInput
                  checked={pageTemplateStyleId === layout.identifier}
                  disabled={disabled}
                  id={`page-layout-${layout.identifier}`}
                  key={layout.name}
                  label={layout.name}
                  name="page-layout"
                  onChange={() => onUpdate(layout)}
                />
              ))}
            </Col>
          </Row>
        </div>
      </Col>
      <Col md={6} xs={4}>
        <OverrideButton
          disabled={disabled}
          onRemove={onRemove}
          onReset={() => onUpdate(pageTemplateStyles[0])}
        />
      </Col>
    </Row>
  );
}

PageTemplateStyleSelector.propTypes = {
  pageTemplateStyleId: PropTypes.string,
  pageTemplateStyles: PropTypes.arrayOf(PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  onRemove: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
};
